import { render, staticRenderFns } from "./SpOrderCreateEdit.vue?vue&type=template&id=5560b416&scoped=true&"
import script from "./SpOrderCreateEdit.vue?vue&type=script&lang=js&"
export * from "./SpOrderCreateEdit.vue?vue&type=script&lang=js&"
import style0 from "./SpOrderCreateEdit.vue?vue&type=style&index=0&id=5560b416&scoped=true&lang=css&"
import style1 from "./SpOrderCreateEdit.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5560b416",
  null
  
)

export default component.exports